/* ==========================================================================
   Mon Chou — engraving option tabs fade (pairs with assets/mc-anim.css §6)
   Added 2026-10-13 (Claude, "3.80"). Loaded globally from snippets/mc-cart.liquid.
   --------------------------------------------------------------------------
   The pills (Valgfri tekst / Koordinater / Håndskrift) are
   .adev-custom-buttons span[data-adev-option]; adev.js shows/hides each
   option's panels synchronously in its jQuery click handler. We note which
   panels were hidden just before that handler runs (capture phase), and once
   the click has bubbled back up to window — same task, before the browser
   paints the new state (rAF as a fallback) — give every panel that has since
   appeared the .mc-tab-in class, which runs
   the same fade as the product-info accordion. Panels that stay visible
   across a switch (e.g. the text field under Koordinater) are left alone,
   and nothing animates on page load.
   ========================================================================== */
(function () {
  if (window.__mcTabFade) return;
  window.__mcTabFade = true;

  var TAB = '.adev-custom-buttons [data-adev-option]';
  var PANELS = [
    '.mc-personalizer .mc-field-text',
    '.mc-personalizer .mc-field-font',
    '.mc-personalizer .mc-field-upload',
    '.adev-map-cord-selector',
    '.adev-handwritting-tip',
    '.adev-handwritting-images'
  ].join(',');

  function shown(el) { return el.getClientRects().length > 0; }

  function replay(el) {
    el.classList.remove('mc-tab-in');
    void el.offsetWidth; // restart the animation if it is still running
    el.classList.add('mc-tab-in');
  }

  var pending = null;

  function apply() {
    if (!pending) return;
    var list = pending;
    pending = null;
    list.forEach(function (el) { if (shown(el)) replay(el); });
  }

  // capture phase on document: runs before adev.js's handler on the pill
  document.addEventListener('click', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest(TAB) : null;
    if (!tab || tab.classList.contains('active')) return; // re-tapping the open tab changes nothing
    var hidden = Array.prototype.filter.call(document.querySelectorAll(PANELS), function (el) {
      return !shown(el);
    });
    if (!hidden.length) return;
    pending = hidden;
    // fallback if something stops the click from bubbling: still before paint
    requestAnimationFrame(apply);
  }, true);

  // bubble phase on window: adev.js has shown the new panels by now, so the
  // fade starts in the same task, before anything is painted
  window.addEventListener('click', apply);

  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'mc-tab-fade' && e.target.classList) {
      e.target.classList.remove('mc-tab-in');
    }
  });
})();
